import * as React from 'react';
import { WithSearch } from "@elastic/react-search-ui";

export default function GroupLabel({ currentGroup }) {
  const separator = ' | ';

  let allowedAttributes = [];
  if (currentGroup && currentGroup.labelFields) {
    allowedAttributes = currentGroup.labelFields.split(',').map(item => item.trim()).filter(item => item.length > 0);
  }

  if (allowedAttributes.length < 1) {
    return null;
  }

  return (
    <WithSearch mapContextToProps={({ filters }) => ({ filters })}>
      {({ filters }) => {
        const parts = allowedAttributes.reduce((acc, attr) => {
          const filter = filters.find(f => f.field === attr);
          const value = filter?.values?.[filter.values.length - 1];
          if (value) acc.push(value);
          return acc;
        }, []);

        if (parts.length === 0) {
          return null;
        }

        return (
          <div>
            {parts.join(separator)}
          </div>
        );
      }}
    </WithSearch>
  );
}
